export default __webpack_public_path__ + "static/media/Group.af3966be.svg";